import React from 'react';

const Toast = ({ toast }) => {
  if (!toast.show) return null;

  return (
    <div className="fixed top-4 right-4 z-50 animate-slide-up">
      <div className={`max-w-sm w-full bg-white shadow-lg rounded-lg pointer-events-auto ring-1 ring-black ring-opacity-5 overflow-hidden ${
        toast.type === 'success' ? 'border-l-4 border-green-500' : 'border-l-4 border-red-500'
      }`}>
        <div className="p-4">
          <div className="flex items-start">
            <div className="flex-shrink-0">
              {toast.type === 'success' ? (
                <svg className="h-6 w-6 text-green-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              ) : (
                <svg className="h-6 w-6 text-red-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              )}
            </div>
            <div className="ml-3 w-0 flex-1 pt-0.5">
              <p className="text-sm font-medium text-gray-900">
                {toast.type === 'success' ? 'Erfolgreich!' : 'Fehler!'}
              </p>
              <p className="mt-1 text-sm text-gray-500">
                {toast.message}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Toast;